import Divider from '@mui/material/Divider'
import styles from './DividerComponent.module.scss'
import React from 'react'

type DividerComponentProps = {
  label?: string
  content?: React.ReactNode
  classNameContainer?: string
  classNameLabel?: string
  classNameDivider?: string
  customButton?: React.ReactNode
  onClickBtn?: () => void
}

const DividerComponent = (props: DividerComponentProps) => {
  const { label, content, classNameLabel, classNameDivider, classNameContainer, customButton } = props

  return (
    <div
      className={`${styles.dividerContainer} ${classNameContainer}`}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
        <div className={`${styles.textContent} ${classNameLabel}`}>{content ? content : label}</div>
        <Divider className={`${styles.divider} ${classNameDivider}`} style={{ flexGrow: 1, marginLeft: '8px' }} />
      </div>
      {customButton && (
        <div style={{ marginLeft: '16px' }} onClick={props.onClickBtn}>
          {customButton}
        </div>
      )}
    </div>
  )
}

export default DividerComponent
